import { render, staticRenderFns } from "./Cdgl.vue?vue&type=template&id=83d4fcd2&scoped=true&"
import script from "./Cdgl.vue?vue&type=script&lang=js&"
export * from "./Cdgl.vue?vue&type=script&lang=js&"
import style0 from "./Cdgl.vue?vue&type=style&index=0&id=83d4fcd2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d4fcd2",
  null
  
)

export default component.exports